import{Progress as s}from"@mantine/core";import{jsx as e}from"@emotion/react/jsx-runtime";function r(o){return e(s,{...o})}export{r as Progress};
